import { Component, OnInit, Input, OnChanges } from "@angular/core";
import { KreFormFieldConfig } from "@kre-form/core";
import { FormBuilder, Validators, FormArray, FormGroup } from "@angular/forms";
import * as _ from "lodash";
interface Item {
  value: string;
  label: string;
}
@Component({
  selector: "demo-event",
  templateUrl: "./event.component.html",
  styleUrls: ["./event.component.scss"],
})
export class EventComponent implements OnInit, OnChanges {
  @Input() data: KreFormFieldConfig = {};
  @Input() fields: KreFormFieldConfig[] = [];
  @Input() options: Item[] = [];
  @Input() triggerJson: any[] = [];

  validateForm: FormGroup;

  get eventList() {
    return this.validateForm.get("eventList") as FormArray;
  }

  constructor(private fb: FormBuilder) {
    this.validateForm = this.fb.group({});
    this.validateForm.addControl("eventList", this.fb.array([]));
  }

  save() {
    ((this.validateForm as any)!.controls!.eventList![
      "controls"
    ] as FormGroup[])!.forEach((element: FormGroup) => {
      for (const i in element.controls) {
        element.controls[i].markAsDirty();
        element.controls[i].updateValueAndValidity();
      }
    });
  }

  ngOnInit() {
    this.fields = this.fields.filter((el) => el.type !== "datetime");
    if (!!this.triggerJson && this.triggerJson.length > 0) {
      this.triggerJson.forEach((el) => {
        this.eventList.push(this.addEventList(el));
      });
    }
  }
  ngOnChanges() {}
  add() {
    // console.log(this.validateForm);

    this.save();
    if (!this.validateForm.valid) {
      return;
    }
    this.eventList.push(this.addEventList());
  }

  addEventList(element?: any) {
    return this.fb.group({
      selected: [
        element ? element!.selected || null : null,
        [Validators.required],
      ],
      fieldType: [this.data.type, [Validators.required]],

      secondType: [this.data!.templateOptions!.type],
      required: [this.data!.templateOptions!.required || false],

      fieldName: [this.data!.templateOptions!.label],

      selectItem: [element ? element!.selectItem || null : null],
      selectItems: [element ? element!.selectItems || null : null],

      fieldKey: [
        element ? element!.fieldKey || null : null,
        [Validators.required],
      ],

      changeFieldName: [element ? element!.changeFieldName || null : null, []],

      changeFieldType: [
        element ? element!.changeFieldType || null : null,
        [Validators.required],
      ],

      changeAction: [
        element ? element!.changeAction || null : null,
        [Validators.required],
      ],
      changeActions: [
        element ? element!.changeActions || null : null,
        [Validators.required],
      ],

      changeToItem: [
        element ? element!.changeToItem || null : null,
        [Validators.required],
      ],
      changeToItems: [
        element ? element!.changeToItems || null : null,
        [Validators.required],
      ],

      maxLength: [element ? element!.maxLength : null],
      maxLengthIncludes: [element ? element!.maxLengthIncludes || null : null],
      minLength: [element ? element!.minLength : null],
      minLengthIncludes: [element ? element!.minLengthIncludes || null : null],

      maxIncludes: [element ? element!.maxIncludes || null : null],
      max: [element ? element!.max : null],
      minIncludes: [element ? element!.minIncludes || null : null],
      min: [element ? element!.min : null],

      // maxDateTime: [element ? element!.maxDateTime : null],
      // maxDateTimeIncludes: [
      //   element ? element!.maxDateTimeIncludes || null : null,
      // ],
      // minDateTime: [element ? element!.minDateTime : null],
      // minDateTimeIncludes: [
      //   element ? element!.minDateTimeIncludes || null : null,
      // ],

      specValue: [element ? element!.specValue || null : null],
      // specDateTime: [element ? element!.specValue || null : null],

      fixedValue: [element ? element!.fixedValue || null : null],
      // fixedDateTime: [element ? element!.fixedValue || null : null],

      code: [element ? element!.code || Math.random() : Math.random()],
    });
  }
  removeEventList(i: number) {
    this.eventList.removeAt(i);
  }
}
